"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var items = [];

var InMemoryLibraryService = /*#__PURE__*/function () {
  function InMemoryLibraryService() {
    _classCallCheck(this, InMemoryLibraryService);
  }

  _createClass(InMemoryLibraryService, [{
    key: "getItems",
    value: function getItems() {
      return Promise.resolve(items);
    }
  }, {
    key: "setItems",
    value: function setItems(data) {
      items = data;
    }
  }, {
    key: "saveItem",
    value: function saveItem(id, name, state) {
      if (!id) {
        var _item = {
          id: items.length + 1,
          name: name,
          state: state
        };
        items.push(_item);
        return Promise.resolve(_item);
      }

      var idx = items.findIndex(function (item) {
        return item.id === id;
      });

      if (idx || idx < 0) {
        return Promise.reject();
      }

      var item = items[idx];
      items[idx] = _objectSpread(_objectSpread({}, item), {
        name: name,
        state: state
      });
    }
  }, {
    key: "deleteItem",
    value: function deleteItem(id) {
      items = items.filter(function (item) {
        return item.id !== id;
      });
      return Promise.resolve();
    }
  }]);

  return InMemoryLibraryService;
}();

var _default = InMemoryLibraryService;
exports["default"] = _default;